import {
    inspectionItemLabel,
    InspectionTask,
} from 'aos-services/src/services/tasks/types/task/InspectionTask'
import { TaskTemplate } from 'aos-services/src/services/tasks/types/task/TaskTemplate'
import { Box } from 'aos-ui/src/components/base/Box'
import { PropsListEntry } from 'aos-ui/src/components/list/PropsList'
import { TFunction } from 'i18next'
import React from 'react'

export const inspectionTaskPropertyList =
    (translate: TFunction) =>
    (t: InspectionTask | TaskTemplate<InspectionTask>): PropsListEntry[] => [
        [
            'tasks.task-preview.inspection',
            !!t.items?.length && (
                <Box>
                    {t.items.map((ch, index) => (
                        <Box key={index}>{inspectionItemLabel(translate)(ch)}</Box>
                    ))}
                </Box>
            ),
        ],
    ]
